import React, { Component } from 'react';
import { Editor as EditorDraft } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { quandoMudar, iniciarEditor } from "./actions";

const MAXIMO_CARACTERES = 5000;

const padrao = {
  toolbarClassName: "sr-toolbar",
  wrapperClassName: "sr-wrapper",
  editorClassName: "sr-editor",
  localization: {
    locale: 'pt'
  }
}

const somenteLeituraPadrao = {
  ...padrao,
  toolbarHidden: true,
  readOnly: true
}

class Editor extends Component {

  quandoMudar = editorState => {
    const { quandoMudar, chave = "padrao" } = this.props;
    quandoMudar(chave, editorState);
  }

  verificarTotalCaracteres = (caracter, editorState) => {
    const TOTAL_CARACTERES = editorState.getCurrentContent().getPlainText('').length;

    if (TOTAL_CARACTERES > (this.props.maxlength || MAXIMO_CARACTERES)) {
      return "handled";
    }
  }

  render() {
    const { editorState, iniciarEditor, chave, conteudo = "", somenteLeitura = false, pequeno = false } = this.props;
    const { editorClassName } = padrao;

    let propriedades = {};

    if (somenteLeitura) {
      propriedades = {
        ...somenteLeituraPadrao,
        editorClassName: `${editorClassName} sr-editor--somente-leitura`,
        editorState: iniciarEditor(chave, conteudo, somenteLeitura),
      }
    }
    else {
      propriedades = {
        ...padrao,
        editorClassName: `${editorClassName} ${pequeno ? "sr-editor--tamanho-pequeno" : ""}`,
        editorState: editorState,
        onEditorStateChange: this.quandoMudar,
        handleBeforeInput: this.verificarTotalCaracteres,
        placeholder: this.props.placeholder ? this.props.placeholder : ""
      }
    }

    return <EditorDraft {...propriedades} />
  }
}

const mapStateToProps = ({ editor: { editores } }, { chave = "padrao" }) => ({ editorState: editores[chave]});

const mapDispatchToProps = dispatch => bindActionCreators({
  quandoMudar,
  iniciarEditor,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Editor);


// WEBPACK FOOTER //
// ./src/componentes/editor/index.js